import { endOfDayInUserTimeZone, subDaysInUserTimeZone } from '@/helpers';

/** Customer P/L — preset period drives concrete `betDate` sent to API. */
export interface FiltersWithCustomerPlDatePeriodPreset {
    betDatePeriod: { value: string | null };
    betDate: { value: [Date, Date] | null };
}

export function applyCustomerPlDatePeriodPreset(filtersCopy: FiltersWithCustomerPlDatePeriodPreset): void {
    if (!filtersCopy.betDatePeriod.value || filtersCopy.betDatePeriod.value === 'range') return;

    if (filtersCopy.betDatePeriod.value === 'lifetime') {
        filtersCopy.betDate.value = null;
        return;
    }

    const now = new Date();
    const days = Number(filtersCopy.betDatePeriod.value);

    if (!Number.isFinite(days) || days <= 0) return;

    filtersCopy.betDate.value = [subDaysInUserTimeZone(now, days), endOfDayInUserTimeZone(now)];
}
